<div class="titulo-header div-body" style="font-family: 'Nunito', sans-serif">
  <div class="titulo-textos">
    <span class="titulo" style="font-family: 'Nunito', sans-serif"
      >Relatórios</span
    >
    <span class="subtitulo" style="font-family: 'Nunito', sans-serif"
      >Visualize os relatórios dessa rota</span
    >
  </div>
  <button class="close-button" mat-dialog-close mat-icon-button>
    <mat-icon fontSet="material-icons-outlined">close</mat-icon>
  </button>
</div>

<div
  class="rota-detalhes-dialog-header"
  mat-dialog-title
  style="font-family: 'Nunito', sans-serif"
>
  <div class="cabecalho-wrapper">
    <app-cabecalho-rota
      [dados]="(resumo$ | async)!"
      [loaded]="loaded$"
      [camposGrid]="camposGrid"
      [rastreamento]="tiposRastreamentoPermitidos"
    ></app-cabecalho-rota>
  </div>
</div>

<mat-dialog-content
  class="rota-detalhes-dialog-container"
  style="font-family: 'Nunito', sans-serif"
>
  <div class="tabs-with-buttons">
    <mat-tab-group #matTabGroup (selectedTabChange)="onTabChange($event)">
      <mat-tab label="{{ 'ROUTE_REPORT.SUMMARY.TITLE' | translate }}">
        <ng-template matTabContent>
          <div class="resumo-cards">
            <app-rota-detalhes-resumo
              [resumo$]="resumo$"
              [loaded$]="loaded$"
            ></app-rota-detalhes-resumo>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab
        label="{{ 'ROUTE_REPORT.REPORT.TITLE' | translate }}"
        *ngIf="!exibeAbaRecibos"
      >
        <ng-template matTabContent>
          <div class="resumo-cards">
            <!-- Usando o componente de relatório dinâmico ao invés do componente original -->
            <app-relatorio-dinamico-xls
              #relatorioDinamicoXls
              [resumo]="rotaDetalhesRelatorio!"
              *ngIf="rotaDetalhesRelatorio"
            >
            </app-relatorio-dinamico-xls>

            <!-- Loading state -->
            <div
              *ngIf="!rotaDetalhesRelatorio"
              class="loading-container"
              style="font-family: 'Nunito', sans-serif"
            >
              <mat-spinner diameter="50"></mat-spinner>
              <p style="font-family: 'Nunito', sans-serif">
                Carregando relatório...
              </p>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab
        label="{{ 'ROUTE_REPORT.RECEIPTS.TITLE' | translate }}"
        *ngIf="exibeAbaRecibos && (exibeRecibos$ | async)"
      >
        <ng-template matTabContent>
          <div class="resumo-cards">
            <app-rota-detalhes-recibos
              [loaded$]="docLoaded$"
              [recibos$]="recibos$"
              [adiantamento$]="adiantamento$"
              [despesas$]="despesas$"
              (downloadFile$)="download($event)"
            >
            </app-rota-detalhes-recibos>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab
        label="{{ 'ROUTE_REPORT.DOCUMENTS.TITLE' | translate }}"
        *ngIf="!exibeAbaRecibos"
      >
        <ng-template matTabContent>
          <div class="resumo-cards">
            <app-rota-detalhes-documentos
              [loaded$]="docLoaded$"
              [documentos$]="documentos$"
              [viewMode]="viewMode"
              (downloadFile$)="download($event)"
            >
            </app-rota-detalhes-documentos>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

    <!-- Botões alinhados com as abas -->
    <div class="buttons-container tab-level-buttons">
      <div class="action-buttons">
        <!-- Botões PDF e Excel - apenas na aba Relatório (índice 1) -->
        <ng-container *ngIf="!exibeAbaRecibos && selectedTabIndex === 1">
          <button
            class="btn-header"
            (click)="printRelatorioCustom()"
            mat-flat-button
            [disabled]="!((loaded$ | async) ?? 0)"
            style="font-family: 'Nunito', sans-serif"
          >
            <mat-icon fontSet="material-icons-outlined">print</mat-icon>
            {{ "ROUTE_REPORT.BUTTONS.PDF" | translate }}
          </button>

          <button
            class="btn-header"
            (click)="printRelatorioCustomXls()"
            mat-flat-button
            [disabled]="!((loaded$ | async) ?? 0)"
            style="font-family: 'Nunito', sans-serif"
          >
            <mat-icon
              fontSet="material-icons-outlined"
              svgIcon="view_list"
            ></mat-icon>
            {{ "ROUTE_REPORT.BUTTONS.EXCEL" | translate }}
          </button>
        </ng-container>

        <!-- Botões Documents e Toggle View - apenas na aba Documentos (índice 2) -->
        <ng-container *ngIf="!exibeAbaRecibos && selectedTabIndex === 2">
          <div
            [matTooltipDisabled]="
              !((loadedDownload$ | async) ?? 0) || possuiDocumentos()
            "
            matTooltip="{{ 'ROUTE_REPORT.DOCUMENTS.EMPTY_LIST' | translate }}"
          >
            <button
              class="btn-header"
              (click)="download()"
              mat-flat-button
              [disabled]="!((loaded$ | async) ?? 0) || !possuiDocumentos()"
              style="font-family: 'Nunito', sans-serif"
            >
              <mat-icon *ngIf="!((loadedDownload$ | async) ?? 0)" class="rotate"
                >hourglass_empty</mat-icon
              >
              <mat-icon
                *ngIf="loadedDownload$ | async"
                fontSet="material-icons-outlined"
                svgIcon="seta_download"
              ></mat-icon>
              {{ "ROUTE_REPORT.BUTTONS.DOCUMENTS" | translate }}
            </button>
          </div>

          <!-- Toggle View Button - Lista/Imagem -->
          <div class="view-toggle-container">
            <div class="btn-view-toggle">
              <!-- Lado esquerdo - Lista -->
              <div
                class="toggle-side left"
                [class.active]="viewMode === 'list'"
                (click)="setViewMode('list')"
                (keydown.enter)="setViewMode('list')"
                (keydown.space)="setViewMode('list')"
                tabindex="0"
                role="button"
                aria-label="Modo lista"
              >
                <mat-icon fontSet="material-icons-outlined">view_list</mat-icon>
              </div>
              <!-- Lado direito - Imagem -->
              <div
                class="toggle-side right"
                [class.active]="viewMode === 'image'"
                (click)="setViewMode('image')"
                (keydown.enter)="setViewMode('image')"
                (keydown.space)="setViewMode('image')"
                tabindex="0"
                role="button"
                aria-label="Modo imagem"
              >
                <mat-icon fontSet="material-icons-outlined"
                  >view_module</mat-icon
                >
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</mat-dialog-content>
